<template>
  <div>
    <base-header type="gradient-default" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Mask -->
      <span class="mask bg-gradient-default opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-8 col-md-10">
            <p class="text-white my-3">
              Aqui você pode definir os cursos de capacitação a serem
              disponibilizados para as startups incubadas. Além disso, você
              confere a Trilha de Qualificação disponibilizada pela Stars.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-12">
          <cursos-list />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CursosList from "./Trilha/CursosList";

export default {
  name: "admin-trilha",
  components: {
    CursosList,
  },
};
</script>
